import { Component, Input, OnInit } from '@angular/core';
import { InfoItem, ResponsiveService } from '@frk/eds-components';
import { FundId } from '@products/types';
import { Observable } from 'rxjs';

@Component({
  selector: 'ft-week-range',
  templateUrl: './week-range.component.html',
  styleUrls: ['./week-range.component.scss'],
})
export class WeekRangeComponent {
  @Input() weeksData: InfoItem[];
  @Input() fundId: FundId;
}
